/* eslint-disable no-underscore-dangle */
import moment from 'moment';
import { actionCreator } from 'utils';
import { isArray } from 'lodash';
import * as LogisticTypes from '../types/logisticTypes';

const prevMonth = moment().subtract(3, 'months');
const startDate = prevMonth.format('YYYY-MM-DD 00:00:00');
const nowDate = moment().format('YYYY-MM-DD 23:59:59');

const initState = {
    loading: false,
    error: false,
    listing: null,
    submitting: [],
    printLabelPopup: false,
    offset: 0,
    limit: 50,
    sort: {
        key: 'created_at',
        type: 'desc',
    },
    checked: [],
    comment: {
        loading: false,
        error: false,
        success: false,
    },
    delete: {
        loading: false,
        error: false,
    },
    filters: {
        order_item_number: '',
        order_number: '',
        productGroup: [],
        specifications: [],
        quantity: '',
        expected_shipping_date: undefined,
        state: undefined,
        source: undefined,
        shippingMethod: [],
        customer: [],
        created_at: [startDate, nowDate],
        consignment_number: '',
    },
    configurations: {
        loading: false,
        error: false,
        listing: null,
    },
    productGroups: {
        loading: false,
        error: false,
        listing: null,
    },
    neededData: {
        users: [],
        configurations: [],
        productGroups: [],
        shippings: [],
    },
    convocationTNT: {
        listing: {
            loading: false,
            error: false,
            data: [],
            offset: 0,
            limit: 10,
            filters: {
                submit_date: [],
                collection_date: [],
            },
            sort: {
                key: 'created_at',
                type: 'desc',
            },
        },

        send: {
            loading: false,
            error: false,
        },
    },

    TNTLabel: {
        listing: {
            loading: false,
            error: false,
            data: [],
            offset: 0,
            limit: 10,
            sort: {
                key: 'created_at',
                type: 'desc',
            },
        },

        send: {
            loading: false,
            error: false,
        },
    },
};

export default function (state = initState, action) {
    switch (action.type) {
    case LogisticTypes.LOAD_LOGISTIC:
        return Object.assign({}, state, {
            ...state,
            loading: true,
        });

    case actionCreator(LogisticTypes.LOAD_LOGISTIC, 'err'):
        return Object.assign({}, state, {
            ...state,
            submitting: [],
            loading: false,
            error: true,
        });

    case actionCreator(LogisticTypes.LOAD_LOGISTIC, 'res'):
        return Object.assign({}, state, {
            ...state,
            submitting: [],
            loading: false,
            listing: action.data,
        });

    case LogisticTypes.SET_LOGISTIC_NEEDED_DATA:
        return Object.assign({}, state, {
            ...state,
            neededData: action.data,
        });

    case LogisticTypes.SET_LOGISTIC_PAGINATION:
        return Object.assign({}, state, {
            [action.key]: action.pagination,
        });

    case LogisticTypes.SET_LOGISTIC_FILTERS:
        return Object.assign({}, state, {
            filters: {
                ...state.filters,
                [action.key]: action.value,
            },
        });

    case actionCreator(LogisticTypes.SET_LOGISTIC_FILTERS, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case LogisticTypes.RESET_LOGISTIC_FILTERS:
        return Object.assign({}, state, {
            ...state,
            filters: {
                ...initState.filters,
                state: undefined,
                logistics_status: undefined,
            },
        });

    case LogisticTypes.SET_CHECKED_LOGISTIC:
        if (state.checked.includes(action.id)) {
            return Object.assign({}, state, {
                ...state,
                checked: [
                    ...state.checked.filter(c => c !== action.id),
                ],
            });
        }

        if (isArray(action.id)) {
            return Object.assign({}, state, {
                ...state,
                checked: action.id.length !== 0 ? action.id : [],
            });
        }

        return Object.assign({}, state, {
            ...state,
            checked: [
                ...state.checked.filter(c => c !== action.id),
                action.id,
            ],
        });

    case LogisticTypes.SET_LOGISTIC_COMMENT:
        return Object.assign({}, state, {
            ...state,
            comment: {
                loading: true,
                error: false,
                success: false,
            },
        });

    case actionCreator(LogisticTypes.SET_LOGISTIC_COMMENT, 'res'):
        return Object.assign({}, state, {
            ...state,
            comment: {
                loading: action.loading,
                success: true,
                error: false,
            },
        });

    case actionCreator(LogisticTypes.SET_LOGISTIC_COMMENT, 'err'):
        return Object.assign({}, state, {
            ...state,
            comment: {
                ...state.comment,
                error: true,
                loading: false,
            },
        });

    case LogisticTypes.SIMPLE_PRINT_LABEL:
        return Object.assign({}, state, {
            ...state,
            submitting: [],
        });

    case actionCreator(LogisticTypes.SIMPLE_PRINT_LABEL, 'res'):
        return Object.assign({}, state, {
            ...state,
            printLabelPopup: false,
            submitting: [],
        });

    case actionCreator(LogisticTypes.SIMPLE_PRINT_LABEL, 'err'):
        return Object.assign({}, state, {
            ...state,
            printLabelPopup: false,
            submitting: [],
        });

    case LogisticTypes.PRINT_GROUPED_LABEL:
        return Object.assign({}, state, {
            ...state,
            submitting: state.checked,
        });

    case actionCreator(LogisticTypes.PRINT_GROUPED_LABEL, 'res'):
        return Object.assign({}, state, {
            ...state,
            printLabelPopup: false,
            submitting: [],
        });

    case actionCreator(LogisticTypes.PRINT_GROUPED_LABEL, 'err'):
        return Object.assign({}, state, {
            ...state,
            printLabelPopup: false,
            submitting: [],
        });

    case LogisticTypes.SET_PRINT_LABEL_POPUP:
        return Object.assign({}, state, {
            ...state,
            printLabelPopup: action.data,
        });

    case LogisticTypes.SET_SUBMITTING:
        return Object.assign({}, state, {
            ...state,
            submitting: action.data,
        });

    case LogisticTypes.SEND_DEMAND_CONVOCATION_TNT:
        return Object.assign({}, state, {
            ...state,
            convocationTNT: {
                ...state.convocationTNT,
                send: {
                    ...state.convocationTNT.send,
                    loading: true,
                },
            },
        });

    case actionCreator(LogisticTypes.SEND_DEMAND_CONVOCATION_TNT, 'res'):
        return Object.assign({}, state, {
            ...state,
            convocationTNT: {
                ...state.convocationTNT,
                send: {
                    ...state.convocationTNT.send,
                    loading: false,
                },
            },
        });

    case actionCreator(LogisticTypes.SEND_DEMAND_CONVOCATION_TNT, 'err'):
        return Object.assign({}, state, {
            ...state,
            convocationTNT: {
                ...state.convocationTNT,
                send: {
                    ...state.convocationTNT.send,
                    loading: false,
                    error: true,
                },
            },
        });

    case LogisticTypes.LOAD_TNT_DOCUMENTS:
        return Object.assign({}, state, {
            ...state,
            convocationTNT: {
                ...state.convocationTNT,
                listing: {
                    ...state.convocationTNT.listing,
                    loading: true,
                    error: false,
                },
            },
        });

    case actionCreator(LogisticTypes.LOAD_TNT_DOCUMENTS, 'res'):
        return Object.assign({}, state, {
            ...state,
            convocationTNT: {
                ...state.convocationTNT,
                listing: {
                    ...state.convocationTNT.listing,
                    loading: false,
                    data: action.data,
                },
            },
        });

    case actionCreator(LogisticTypes.LOAD_TNT_DOCUMENTS, 'err'):
        return Object.assign({}, state, {
            ...state,
            convocationTNT: {
                ...state.convocationTNT,
                listing: {
                    ...state.convocationTNT.listing,
                    loading: false,
                    error: true,
                },
            },
        });

    case LogisticTypes.SET_TNT_DOCUMENTS_PAGINATION:
        return Object.assign({}, state, {
            convocationTNT: {
                ...state.convocationTNT,
                listing: {
                    ...state.convocationTNT.listing,
                    [action.key]: action.pagination,
                },
            },
        });

    case LogisticTypes.SET_TNT_DOCUMENTS_FILTERS:
        return Object.assign({}, state, {
            convocationTNT: {
                ...state.convocationTNT,
                listing: {
                    ...state.convocationTNT.listing,
                    filters: {
                        ...state.convocationTNT.listing.filters,
                        [action.key]: action.value,
                    },
                },
            },
        });

    case LogisticTypes.RESET_TNT_DOCUMENTS_FILTERS:
        return Object.assign({}, state, {
            convocationTNT: {
                ...state.convocationTNT,
                listing: {
                    ...state.convocationTNT.listing,
                    filters: initState.convocationTNT.listing.filters,
                },
            },
        });

    case LogisticTypes.DELETE_LOGISTIC_LABEL:
        return Object.assign({}, state, {
            ...state,
            delete: {
                ...state.delete,
                loading: action.data.loading,
                error: false,
            },
        });

    case actionCreator(LogisticTypes.DELETE_LOGISTIC_LABEL, 'res'):
        return Object.assign({}, state, {
            ...state,
            delete: {
                ...state.delete,
                loading: false,
            },
        });

    case actionCreator(LogisticTypes.DELETE_LOGISTIC_LABEL, 'err'):
        return Object.assign({}, state, {
            ...state,
            delete: {
                ...state.delete,
                loading: false,
                error: true,
            },
        });

    case LogisticTypes.LOAD_TNT_LABEL:
        return Object.assign({}, state, {
            ...state,
            TNTLabel: {
                ...state.TNTLabel,
                listing: {
                    ...state.TNTLabel.listing,
                    loading: true,
                    error: false,
                },
            },
        });

    case actionCreator(LogisticTypes.LOAD_TNT_LABEL, 'res'):
        return Object.assign({}, state, {
            ...state,
            TNTLabel: {
                ...state.TNTLabel,
                listing: {
                    ...state.TNTLabel.listing,
                    loading: false,
                    data: action.data,
                },
            },
        });

    case actionCreator(LogisticTypes.LOAD_TNT_LABEL, 'err'):
        return Object.assign({}, state, {
            ...state,
            TNTLabel: {
                ...state.TNTLabel,
                listing: {
                    ...state.TNTLabel.listing,
                    loading: false,
                    error: true,
                },
            },
        });

    case LogisticTypes.SET_TNT_LABEL_PAGINATION:
        return Object.assign({}, state, {
            TNTLabel: {
                ...state.TNTLabel,
                listing: {
                    ...state.TNTLabel.listing,
                    [action.key]: action.pagination,
                },
            },
        });

    case LogisticTypes.SET_TNT_LABEL_FILTERS:
        return Object.assign({}, state, {
            TNTLabel: {
                ...state.TNTLabel,
                listing: {
                    ...state.TNTLabel.listing,
                    filters: {
                        ...state.TNTLabel.listing.filters,
                        [action.key]: action.value,
                    },
                },
            },
        });

    case LogisticTypes.RESET_TNT_LABEL_FILTERS:
        return Object.assign({}, state, {
            TNTLabel: {
                ...state.TNTLabel,
                listing: {
                    ...state.TNTLabel.listing,
                    filters: initState.TNTLabel.listing.filters,
                },
            },
        });

    default:
        return state;
    }
}
